import { Injectable, Injector } from '@angular/core';
import { AspObject } from '../asp/AspObject';
import { IMapClickHandler, IMapMngr } from '../asp/interfaces';

export let AppInjector: Injector;

@Injectable({ providedIn: 'root' })
export class InjectService {
  constructor(private injector: Injector) {
    AppInjector = injector;
  }
}

// ARO Service
export interface IAro {
  showAro(objectId): boolean;
  hideAro(): void;
  isShown(): boolean;
  getShownId();
  updateLocation();
}
export interface IAroTable {
  show(objectIds: Set<any>): void;
  hide(): void;
  isShown(): boolean;
  getObjectIds(): Set<any>;
}

// Objects Menu Interface
export interface IMenu {
  showObjectsMenu(objects: AspObject[], event, mapMngr: IMapMngr, mapClickHandler?: IMapClickHandler): boolean;
  showContextMenu(objects: AspObject[], event, mapMngr: IMapMngr): boolean;
  handleKeyboardEvent(event: KeyboardEvent): boolean; // Return true if key was handled
  hideMenus();
}

// Status Bar Interface
export interface IStatusBar {
  refresh();
}
